import CommonRecentFileRow from './CommonRecentFileRow';

export default CommonRecentFileRow;
